import { render, staticRenderFns } from "./PageTable.vue?vue&type=template&id=08a2f1f4&scoped=true&"
import script from "./PageTable.vue?vue&type=script&lang=js&"
export * from "./PageTable.vue?vue&type=script&lang=js&"
import style0 from "./PageTable.vue?vue&type=style&index=0&id=08a2f1f4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a2f1f4",
  null
  
)

export default component.exports